export enum ThemeType {
  light = 'Light',
  dark = 'Dark'
}